// Grievance Overview — summary stat block: totals by status/category/department,
// avg/median days-to-close, % with resident notification.
import React from "react";
import { ReportShell, Card, SectionTitle, MiniBars, KPITile, fmtNum } from "./_shared";
import {
  CATEGORIES, STATUSES, categoryLabel, departmentLabel, statusLabel,
  daysToClose, average, median, countBy, CLOSED_STATUSES,
} from "../grievanceModel";

export default function GrievanceOverview({ records = [] }) {
  const byStatus = countBy(records, (r) => r.status).map((s) => ({ label: statusLabel(s.key), value: s.count, color: STATUSES[s.key]?.color }));
  const byCategory = countBy(records, (r) => r.category).map((c) => ({ label: categoryLabel(c.key), value: c.count, color: CATEGORIES[c.key]?.color }));
  const byDept = countBy(records, (r) => r.department).map((d) => ({ label: departmentLabel(d.key), value: d.count, color: "var(--ed-brand-lift)" }));

  const closeDays = records.map(daysToClose).filter((d) => d != null);
  const avg = average(closeDays);
  const med = median(closeDays);

  const closed = records.filter((r) => CLOSED_STATUSES.includes(r.status));
  const notified = closed.filter((r) => r.residentNotificationSent === true).length;
  const pctNotified = closed.length ? Math.round((notified / closed.length) * 100) : null;

  return (
    <ReportShell title="Grievance Overview" subtitle="Summary statistics across the selected scope.">
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 18 }}>
        <KPITile label="Total Grievances" value={records.length} />
        <KPITile label="Avg Days to Close" value={fmtNum(avg, 1)} tone={avg == null ? "neutral" : avg <= 5 ? "green" : avg <= 10 ? "yellow" : "red"} />
        <KPITile label="Median Days to Close" value={fmtNum(med, 1)} tone={med == null ? "neutral" : med <= 5 ? "green" : med <= 10 ? "yellow" : "red"} />
        <KPITile label="% Resident Notified" value={pctNotified == null ? "—" : `${pctNotified}%`} tone={pctNotified == null ? "neutral" : pctNotified === 100 ? "green" : pctNotified >= 75 ? "yellow" : "red"} sub={`${notified} of ${closed.length} closed`} />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))", gap: 16 }}>
        <Card><SectionTitle>By Status</SectionTitle><MiniBars data={byStatus} /></Card>
        <Card><SectionTitle>By Category</SectionTitle><MiniBars data={byCategory} /></Card>
        <Card><SectionTitle>By Department</SectionTitle><MiniBars data={byDept} /></Card>
      </div>
    </ReportShell>
  );
}
